import _defineProperty from "/codebuild/output/src3064737280/src/landings/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src3064737280/src/landings/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from "react";
import useQueryParams from "./useQueryParams";
function withQueryParams(paramConfigMap, WrappedComponent) {
  var Component = function Component(props) {
    var _useQueryParams = useQueryParams(paramConfigMap),
      _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
      query = _useQueryParams2[0],
      setQuery = _useQueryParams2[1];
    return /* @__PURE__ */React.createElement(WrappedComponent, _objectSpread({
      query: query,
      setQuery: setQuery
    }, props));
  };
  Component.displayName = "withQueryParams(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
  return Component;
}
var withQueryParams_default = withQueryParams;
function withQueryParamsMapped(paramConfigMap, mapToProps, WrappedComponent) {
  var Component = function Component(props) {
    var _useQueryParams3 = useQueryParams(paramConfigMap),
      _useQueryParams4 = _slicedToArray(_useQueryParams3, 2),
      query = _useQueryParams4[0],
      setQuery = _useQueryParams4[1];
    var propsToAdd = mapToProps(query, setQuery, props);
    return /* @__PURE__ */React.createElement(WrappedComponent, _objectSpread(_objectSpread({}, propsToAdd), props));
  };
  Component.displayName = "withQueryParams(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
  return Component;
}
export { withQueryParams_default as default, withQueryParams, withQueryParamsMapped };